import { createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { MaterialPalette } from '@nutrien/cxp-components';

const signandStampStyles = makeStyles(() =>
  createStyles({
    accordianCompleteInspectionTitle: {
      padding: '9px',
    },
    signStampContainer: {
      marginBottom: 1,
      borderRadius: '10px 10px 10px 10px',
      padding: '12px 12px 12px 12px',
      marginTop: '10px',
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
    },
    signStampTitle: {
      position: 'absolute',
      '& .clearSignText': {
        cursor: 'pointer',
        fontWeight: 700,
        fontSize: '14px',
        letterSpacing: '1.25px',
        padding: '28px',
        paddingBottom: '0px',
        color: '#F24965',
      },
    },
    signStampTitle1: {
      position: 'absolute',
      '& .clearSignText': {
        cursor: 'pointer',
        fontWeight: 700,
        fontSize: '14px',
        letterSpacing: '1.25px',
        padding: '28px',
        paddingBottom: '0px',
        color: '#F24965',
      },
    },
    content: {
      display: 'inline-flex',
      cursor: 'default',
    },
    errorGrid: {
      display: 'inline-flex',
      paddingLeft: '55px',
      gap: '7px',
    },
    signatureContainer: {
      marginTop: 0,
      marginBottom: 1,
      borderRadius: '10px 10px 10px 10px',
      position: 'relative',
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
    },
    stampContainer: {
      marginTop: 8,
      marginBottom: 12,
      borderRadius: '10px 10px 10px 10px',
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
    },
    signUploadContainer: {
      border: 'dashed 1.5px #e3dddd6b',
      height: '170px',
      width: '95%',
      alignItems: 'center',
      marginLeft: '2%',
      marginTop: '3%',
      marginBottom: '3%',
    },
    stampUploadContainer: {
      border: 'dashed 1.5px #e3dddd6b',
      height: '170px',
      width: '95%',
      alignItems: 'center',
      marginLeft: '2%',
      marginTop: '3%',
      marginBottom: '3%',
    },
    stampImagePreview: {
      marginLeft: '10px',
    },
    accordianSignStampTitle: {
      padding: '9px',
    },
    accordianRightDiv: {
      padding: '5px',
      display: 'inline',
    },
    accordianButtonLabelGrid: {
      '& .accordianButtonLabel': {
        fontWeight: 700,
        color: MaterialPalette.common.black,
      },
    },
    xfeatherOuterCircle: {
      backgroundColor: '#080908',
      border: '3px solid #080908',
      borderRadius: '50%',
      width: '31px',
      height: '31px',
      marginLeft: '156px',
    },
    xfeatherInnerCircle: {
      borderRadius: '50%',
      backgroundColor: '#080908',
      width: '25px',
      height: '25px',
      border: '1px solid #249236',
    },
    signImageDiv: {
      width: '160px',
      height: '160px',
    },
    signImage: {
      width: '100%',
      height: '80%',
      marginLeft: '15px',
    },
    signLabelDiv: {
      position: 'absolute',
      bottom: '20px',
    },
    signLabel: {
      padding: '8.5px 0px 7.5px 4px',
      fontStyle: 'normal',
    },
    signUploadButDiv: {
      marginLeft: '10px',
    },
    signUploadButton: {
      alignSelf: 'center',
      width: 'fit-content',
      height: 32,
    },
    uploadButtonSignGrid: {
      '& .uploadButtonSign': {
        fontSize: '14px',
        fontWeight: '700',
        lineHeight: '20px',
        letterSpacing: '1.25px',
      },
    },
    stampLabelDiv: {
      marginBottom: '15px',
    },
    xfeatherOuterCircleStamp: {
      backgroundColor: '#080908',
      border: '3px solid #080908',
      borderRadius: '50%',
      width: '31px',
      height: '31px',
      marginLeft: '156px',
    },
    xfeatherInnerCircleStamp: {
      borderRadius: '50%',
      backgroundColor: '#080908',
      width: '25px',
      height: '25px',
      border: '1px solid #249236',
    },
    stampImageDiv: {
      width: '160px',
      height: '160px',
    },
    stampImage: {
      width: '100%',
      height: '80%',
    },
    flexRow: {
      display: 'flex',
      flexDirection: 'row',
      '& .fiLiSubtitle': {
        fontWeight: 600,
        color: '#707070',
        fontStyle: 'normal',
        lineHeight: '20px',
        padding: '0px 15px 8px 15px',
      },
    },
    titleGrid: {
      '& .title': {
        fontSize: '30px',
        lineHeight: '36px',
        paddingBottom: '16px',
        paddingLeft: '10px',
      },
    },

    fiLiSubtitleLeft: {
      padding: '0px 15px 8px 15px',
    },
    signAndStampCompletedView: {
      '& .signAndStampCard': {
        // background: 'rgba(255,255,255,0.5)',
        margin: '0px',
        padding: '16px 16px 16px 16px',
      },
    },
    imageDiv: {
      paddingTop: '30px',
      paddingLeft: '20px',
    },
    uploadButton: {
      backgroundColor: false ? 'rgba(255,255,255,0.38)' : '',
      borderRadius: '4px',
      height: 44,
      alignSelf: 'self-end',
    },
    uploadButtonDisabled: {
      backgroundColor: 'rgba(255,255,255,0.38)',
      borderRadius: '4px',
      height: 44,
    },
    fiLiViewContainer: {
      borderRadius: '10px 10px 10px 10px',
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
      padding: '0px 16px 16px 16px',
      '& .fiLiTitle': {
        color: 'rgba(255,255,255,0.6)',
        padding: '22px 5px 16px 15px',
        lineHeight: '120%',
        letterSpacing: '0.25px',
      },
    },
    dialogText: {
      width: '100%',
      fontSize: 16,
      fontWeight: 300,
      letterSpacing: '0.15px',
      color: 'rgba(255, 255, 255, 0.87)',
    },
    confirmationContainer: {
      padding: '25px 0px 25px 0px',
    },
    confirmButtonDiv: {
      marginLeft: '10px',
    },
    signCanvas: {
      width: '100%',
      height: '100%',
    },
    uploadIconGrid: {
      cursor: 'pointer',
    },
    checkboxGrid: {
      paddingLeft: '10px',
      alignItems: 'center',
      marginRight: '5px',
    },
    checkboxLabel: {
      marginRight: '0px',
    },
    checkBoxUserConsent: {
      marginRight: '0px',
    },
    spanMsg: {
      textDecoration: 'underline',
      paddingRight: '5px',
      paddingLeft: '5px',
      cursor: 'pointer',
    },
    spanMsgDisable: {
      textDecoration: 'underline',
      paddingRight: '5px',
      paddingLeft: '5px',
      color: '#cfcfcf',
    },
    dialogDiv: {
      display: 'inline-flex',
    },
    floatLeftGrid: {
      float: 'left',
    },
    floatRightGrid: {
      float: 'right',
      '& #uploadButtonDisabled': {
        backgroundColor: 'rgba(255,255,255,0.38)',
        borderRadius: '4px',
        height: 44,
      },
      '& #uploadButton': {
        backgroundColor: false ? 'rgba(255,255,255,0.38)' : '',
        borderRadius: '4px',
        height: 44,
      },
      '& .signAndStampUploadButton': {
        backgroundColor: false ? 'rgba(255,255,255,0.38)' : '',
        borderRadius: '4px',
        height: 44,
        alignSelf: 'self-end',
        width: '83%',
        whiteSpace: 'nowrap',
      },
    },
    noImageDiv: {
      height: '150px',
      marginLeft: '10px',
      border: '1px solid #cfcfcf',
      textAlign: 'center',
    },
    userConsentCheckBoxLabel: {
      marginRight: '0px',
    },
    signandStampTitleGrid: {
      paddingLeft: '5px',
      paddingBottom: '16px',
      display: 'inline-flex',
    },
    dialogActionGrid: {
      padding: '4px 8px',
    },
    imageViewGrid: {
      paddingTop: '30px',
      paddingLeft: '20px',
      paddingBottom: '16px',
    },
    noContentDiv: {
      marginTop: '20px',
      marginLeft: '10px',
    },
    deleteContainerGrid: {
      padding: '25px 0px 25px 0px',
    },
    deleteDialogActionGrid: {
      padding: 5,
    },
    signStampFITitleGrid: {
      '& .signStampFITitle': {
        marginLeft: '5px',
        fontSize: '30px',
        fontWeight: 300,
        marginBottom: '16px',
      },
    },
    uploadSendButton: {
      marginRight: '8px',
    },
    loadingStamp: {
      margin: '24px 0px 0px 60px',
    },
    signAndStampNote: {
      fontSize: '20px',
      alignSelf: 'self-end',
      paddingLeft: '10px',
      paddingTop: ' 5px',
      fontWeight: 300,
    },
    stampTitleGrid: {
      padding: '10px 0px',
      display: 'inline-flex',
    },
    paper: {
      top: '0px',
      left: '0px',
      padding: '0px',
    },
    signAndStampContent: {
      '&.MuiDialogContent-root': {
        padding: '0px 10px',
      },
    },
    dialogActions: {
      backgroundColor: 'rgba(255,255,255,0.05)',
    },
    cancelButton: {
      width: '10%',
    },
    dialogDivAdhoc: {
      display: 'inline-flex',
      justifyContent: 'space-between',
    },
    titleAdhoc: {
      height: '55px',
      borderBottom: '1px solid #121212',
    },
    titleGrid1: {
      textAlignLast: 'center',
      paddingTop: '10px',
      paddingLeft: '70px',
    },
    signStampContainerAdhoc: {
      marginBottom: 1,
      borderRadius: '10px 10px 10px 10px',
      padding: '12px 12px 12px 12px',
      marginTop: '10px',
    },
    iconGridAdhoc: {
      padding: '10px',
      textAlignLast: 'end',
      cursor: 'pointer',
    },
  }),
);

export default signandStampStyles;
